import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';

// TODO: starting in ng-19, typeof is supported natively in templates. Probably will switch out once upgraded >= 19
/** Standalone directive to check typeOf value to determine if to render */
@Directive({
    selector: '[isTypeof]',
    standalone: true,
})
export class IsTypeofDirective implements OnChanges
{
    @Input('isTypeof') value: string | any;
    @Input('isTypeofCheck') typeCheck = 'string';

    constructor(
            private _vcr: ViewContainerRef,
            private _tpl: TemplateRef<any>,
    ){
    }

    ngOnChanges({ value }: SimpleChanges) {
        this._vcr.clear();

        if (typeof(value) === this.typeCheck) {
            this._vcr.createEmbeddedView(this._tpl);
        }
    }
}
